import type { ReactNode } from "react";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

interface HeaderProps {
  Actions?: ReactNode;
  addHeaderPadding?: boolean;
  fixed?: boolean;
  title: ReactNode;
}

export const Header = ({
  fixed,
  title,
  addHeaderPadding,
  Actions,
}: HeaderProps) => (
  <div
    className={anchorClassNames("drawer__header", {
      "drawer__header--fixed": fixed,
      "drawer__header--with-padding": addHeaderPadding,
    })}
  >
    <span className={anchorClassNames("header__title")}>{title}</span>
    <div className={anchorClassNames("header__actions")}>{Actions}</div>
  </div>
);
